import outputs from 'root/cfOutput'
import CognitoUserPool from 'amazon-cognito-identity-js/lib/CognitoUserPool'

const { userPoolId = 'us-east-1_5lxi78vfL', clientId = '6uggp343v79nmn02j7jekj2fba' } = outputs

export default new CognitoUserPool({
	UserPoolId: userPoolId,
	ClientId: clientId,
})
